import { j as e } from "./jsx-runtime.DGlMoOmv.js";
import { useFormContext as U } from "react-hook-form";
import { d as $, e as z, f as H, b as W, g as X } from "./Form.LdCd9gH2.js";
import * as c from "react";
import { u as Y, c as N, a as h } from "./index.stoqs9MZ.js";
import { u as C } from "./index.B4ZV02se.js";
import { P as g } from "./index.DMLWxr4u.js";
import { c as E, R as J, I as Q } from "./index.BwKnBOdH.js";
import { u as Z } from "./index.BhJrV2wu.js";
import { u as ee } from "./index.CD933GbG.js";
import { u as re } from "./index.BZPx6jYI.js";
import { P as oe } from "./index.TrmYLGk6.js";
import { L as G } from "./Label.h3I9kFDT.js";
import { c as b } from "./index.CxSWpsOB.js";
var j = "Radio", [te, I] = N(j), [ae, se] = te(j), _ = c.forwardRef(
  (t, n) => {
    const {
      __scopeRadio: o,
      name: s,
      checked: r = !1,
      required: a,
      disabled: d,
      value: i = "on",
      onCheck: l,
      form: p,
      ...u
    } = t, [v, x] = c.useState(null), m = C(n, (w) => x(w)), f = c.useRef(!1), R = v ? p || !!v.closest("form") : !0;
    return /* @__PURE__ */ e.jsxs(ae, { scope: o, checked: r, disabled: d, children: [
      /* @__PURE__ */ e.jsx(
        g.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": r,
          "data-state": S(r),
          "data-disabled": d ? "" : void 0,
          disabled: d,
          value: i,
          ...u,
          ref: m,
          onClick: h(t.onClick, (w) => {
            r || l?.(), R && (f.current = w.isPropagationStopped(), f.current || w.stopPropagation());
          })
        }
      ),
      R && /* @__PURE__ */ e.jsx(
        F,
        {
          control: v,
          bubbles: !f.current,
          name: s,
          value: i,
          checked: r,
          required: a,
          disabled: d,
          form: p,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
_.displayName = j;
var P = "RadioIndicator", k = c.forwardRef(
  (t, n) => {
    const { __scopeRadio: o, forceMount: s, ...r } = t, a = se(P, o);
    return /* @__PURE__ */ e.jsx(oe, { present: s || a.checked, children: /* @__PURE__ */ e.jsx(
      g.span,
      {
        "data-state": S(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: n
      }
    ) });
  }
);
k.displayName = P;
var ie = "RadioBubbleInput", F = c.forwardRef(
  ({
    __scopeRadio: t,
    control: n,
    checked: o,
    bubbles: s = !0,
    ...r
  }, a) => {
    const d = c.useRef(null), i = C(d, a), l = re(o), p = ee(n);
    return c.useEffect(() => {
      const u = d.current;
      if (!u) return;
      const v = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        v,
        "checked"
      ).set;
      if (l !== o && m) {
        const f = new Event("click", { bubbles: s });
        m.call(u, o), u.dispatchEvent(f);
      }
    }, [l, o, s]), /* @__PURE__ */ e.jsx(
      g.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: o,
        ...r,
        tabIndex: -1,
        ref: i,
        style: {
          ...r.style,
          ...p,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
F.displayName = ie;
function S(t) {
  return t ? "checked" : "unchecked";
}
var ne = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], y = "RadioGroup", [de, ke] = N(y, [
  E,
  I
]), D = E(), A = I(), [ce, ue] = de(y), M = c.forwardRef(
  (t, n) => {
    const {
      __scopeRadioGroup: o,
      name: s,
      defaultValue: r,
      value: a,
      required: d = !1,
      disabled: i = !1,
      orientation: l,
      dir: p,
      loop: u = !0,
      onValueChange: v,
      ...x
    } = t, m = D(o), f = Z(p), [R, w] = Y({
      prop: a,
      defaultProp: r ?? null,
      onChange: v,
      caller: y
    });
    return /* @__PURE__ */ e.jsx(
      ce,
      {
        scope: o,
        name: s,
        required: d,
        disabled: i,
        value: R,
        onValueChange: w,
        children: /* @__PURE__ */ e.jsx(
          J,
          {
            asChild: !0,
            ...m,
            orientation: l,
            dir: f,
            loop: u,
            children: /* @__PURE__ */ e.jsx(
              g.div,
              {
                role: "radiogroup",
                "aria-required": d,
                "aria-orientation": l,
                "data-disabled": i ? "" : void 0,
                dir: f,
                ...x,
                ref: n
              }
            )
          }
        )
      }
    );
  }
);
M.displayName = y;
var L = "RadioGroupItem", O = c.forwardRef(
  (t, n) => {
    const { __scopeRadioGroup: o, disabled: s, ...r } = t, a = ue(L, o), d = a.disabled || s, i = D(o), l = A(o), p = c.useRef(null), u = C(n, p), v = a.value === r.value, x = c.useRef(!1);
    return c.useEffect(() => {
      const m = (R) => {
        ne.includes(R.key) && (x.current = !0);
      }, f = () => x.current = !1;
      return document.addEventListener("keydown", m), document.addEventListener("keyup", f), () => {
        document.removeEventListener("keydown", m), document.removeEventListener("keyup", f);
      };
    }, []), /* @__PURE__ */ e.jsx(
      Q,
      {
        asChild: !0,
        ...i,
        focusable: !d,
        active: v,
        children: /* @__PURE__ */ e.jsx(
          _,
          {
            disabled: d,
            required: a.required,
            checked: v,
            ...l,
            ...r,
            name: a.name,
            ref: u,
            onCheck: () => a.onValueChange(r.value),
            onKeyDown: h((m) => {
              m.key === "Enter" && m.preventDefault();
            }),
            onFocus: h(r.onFocus, () => {
              x.current && p.current?.click();
            })
          }
        )
      }
    );
  }
);
O.displayName = L;
var le = "RadioGroupIndicator", q = c.forwardRef(
  (t, n) => {
    const { __scopeRadioGroup: o, ...s } = t, r = A(o);
    return /* @__PURE__ */ e.jsx(k, { ...r, ...s, ref: n });
  }
);
q.displayName = le;
var V = M, B = O, pe = q;
const me = ({
  className: t,
  disabled: n
}) => /* @__PURE__ */ e.jsx("div", { className: b("tw-size-12 tw-rounded-circular tw-bg-gray-900 radio-group-item-circle", {
  "tw-bg-gray-400": n
}, t) }), K = c.createContext({}), fe = ({
  children: t,
  value: n,
  onValueChange: o,
  variant: s,
  disabled: r,
  errorMsg: a
}) => /* @__PURE__ */ e.jsx(K.Provider, { value: {
  value: n,
  onValueChange: o,
  variant: s,
  disabled: r,
  errorMsg: a
}, children: t }), we = () => {
  const t = c.useContext(K);
  if (!t)
    throw new Error("useRadioGroupContext must be used within a RadioGroupContextProvider");
  return t;
}, T = c.forwardRef(({
  className: t,
  testId: n,
  children: o,
  errorMsg: s,
  value: r,
  onValueChange: a,
  variant: d = "default",
  ...i
}, l) => /* @__PURE__ */ e.jsx(fe, { value: r, onValueChange: a, variant: d, disabled: i.disabled, errorMsg: s, children: /* @__PURE__ */ e.jsx(V, { ref: l, "data-testid": n, className: b("tw-grid tw-gap-16", {
  "tw-pointer-events-none [&_.radio-group-item-box]:tw-border-gray-400 [&_.radio-group-item]:tw-border-gray-400 [&_.radio-group-item-text]:tw-text-gray-500 [&_.radio-group-item-circle]:tw-bg-gray-500": i.disabled
}, t), value: r, onValueChange: a, ...i, children: o }) }));
T.displayName = V.displayName;
const ve = c.forwardRef(({
  className: t,
  label: n,
  note: o,
  value: s,
  disabled: r,
  allowEventBubbling: a,
  typeface: d = "body-2-m",
  ...i
}, l) => {
  const p = c.useRef(null), {
    variant: u,
    value: v,
    disabled: x,
    errorMsg: m,
    onValueChange: f
  } = we(), R = r || x;
  return /* @__PURE__ */ e.jsxs("div", { className: b("tw-grid tw-grid-cols-[auto_1fr] tw-items-center tw-space-x-16", {
    "tw-py-20 tw-px-16 tw-rounded-4 tw-border tw-border-gray-400": u === "box",
    "tw-border-gray-900": u === "box" && s === v,
    "tw-pointer-events-none tw-border-gray-400": R,
    "tw-border-red-800": !!m
  }, t), onMouseDown: (w) => {
    u === "box" && (a || (w.preventDefault(), w.stopPropagation()), f?.(s));
  }, role: u === "box" ? "button" : void 0, tabIndex: u === "box" ? 0 : void 0, onKeyDown: (w) => {
    u === "box" && (w.key === "Enter" || w.key === " ") && (w.preventDefault(), w.stopPropagation(), f?.(s));
  }, children: [
    /* @__PURE__ */ e.jsx(B, { ref: l || p, className: b("tw-aspect-square tw-h-16 tw-w-16 tw-rounded-circular tw-border tw-border-gray-900 tw-text-gray-900 tw-ring-base-white focus:tw-outline-none focus-visible:tw-ring-8 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-8 disabled:tw-pointer-events-none radio-group-item", {
      "tw-pointer-events-none tw-border-gray-400": R
    }, t), value: s, disabled: r, ...i, children: /* @__PURE__ */ e.jsx(pe, { className: "tw-flex tw-items-center tw-justify-center", children: /* @__PURE__ */ e.jsx(me, { disabled: R }) }) }),
    /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(G, { htmlFor: i.id, className: b(`tw-${d} radio-group-item-text`, {
      "tw-text-gray-500": R
    }), children: n }) }),
    /* @__PURE__ */ e.jsx("div", {}),
    o && /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(G, { htmlFor: i.id, className: b("tw-caption-2 tw-text-gray-600 radio-group-item-text", {
      "tw-text-gray-500": R
    }), children: o }) })
  ] });
});
ve.displayName = B.displayName;
const Re = ({
  className: t,
  radioGroupClassName: n,
  label: o,
  subcopy: s,
  note: r,
  name: a,
  children: d,
  ...i
}) => {
  const {
    control: l
  } = U();
  return /* @__PURE__ */ e.jsx($, { control: l, name: a, render: ({
    field: p
  }) => /* @__PURE__ */ e.jsxs(z, { disabled: i.disabled, readOnly: i.readOnly, className: t, children: [
    !!o && /* @__PURE__ */ e.jsx(H, { subcopy: s, required: i.required, children: o }),
    /* @__PURE__ */ e.jsx(W, { forwardErrorMsg: !0, children: /* @__PURE__ */ e.jsx(T, { className: n, onValueChange: p.onChange, defaultValue: p.value, value: p.value, ...i, children: d }) }),
    /* @__PURE__ */ e.jsx(X, { children: r })
  ] }) });
};
Re.displayName = "RadioGroupField";
export {
  B as I,
  T as R,
  ve as a,
  Re as b
};
//# sourceMappingURL=RadioGroupField.BidGcusj.js.map
